<script setup>
import { useUserStore } from '@/stores/user.store.js'
import { useAuthStore } from '@/stores/auth.store.js'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, computed } from 'vue'

const route = useRoute()
const router = useRouter()
const user = useUserStore()
const auth = useAuthStore()
const code = route.query.code
const provider = route.params.provider ? route.params.provider.charAt(0).toUpperCase() + route.params.provider.slice(1) : null

const isLoading = computed(() => {
  return user.isOAuthLoading || auth.isLoading
})

onMounted(() => {
  if (provider && code) {
    auth.signInWithOAuthCallBack(code, provider)
  }
})
</script>

<template>
  <!--  <component :is="user.currentUser ? UserOAuthRedirectView : loginOAuthRedirectView"></component>-->
  <div class="oauth fill-height fill-width d-flex justify-center align-center">
    <v-progress-circular color="primary" :indeterminate="isLoading"></v-progress-circular>
  </div>
</template>

<style scoped>
.oauth {
  background: white !important;
}
</style>
